const PrerequisitesStep = () => {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-primary-500">Prerequisites</h3>
      <p className="text-sm text-neutral-500">
        Review the prerequisites inherited from the selected Job Safety Analysis
        (JSA).
      </p>
      {/* List of prerequisites will go here based on JSA selection */}
      <div className="rounded-lg border border-neutral-200 p-8 text-center text-sm text-neutral-500">
        Select a JSA in the Details step to load prerequisites.
      </div>
    </div>
  );
};

export default PrerequisitesStep;
